import get from 'lodash/get';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import useUser from '../../hooks/useUser';
import {useGetSessionsQuery} from '../../redux/services/sessionApi';
import PatientPaymentScreen from '../../components/patients/PatientPaymentScreen';

import AppDashboard from '../AppDashboard';

const PatientPaymentPage = props => {
  const [pageIndex, setPageIndex] = useState(0);
  const user = useUser();
  const navigate = useNavigate();
  const pageSize = 10;
  const sessionsQuery = useGetSessionsQuery(
    {
      patient_id: user?.patient.id, 
      is_completed: true, 
      skip: pageIndex * pageSize,
      limit: pageSize,
      sort: '-date',
    },
    {skip: !user || !user?.patient.id}
  );
  const childProps = {
    ...props,
    count: sessionsQuery.data?.count || 0,
    sessions: sessionsQuery.data?.data || [],
    isLoading: sessionsQuery.isLoading,
    pageIndex,
    pageSize,
    onPageChange: (e,i) => setPageIndex(i),
  }
  return (
    <AppDashboard
      title='Payments'
      loading={childProps.isLoading}
      hasNoData={!childProps.isLoading && !childProps.sessions}
      onBack={() => navigate('/clients/settings')}
    >
      <PatientPaymentScreen {...childProps} />
    </AppDashboard>
  );
};

export default PatientPaymentPage;
